import { render, staticRenderFns } from "./tick-list.vue?vue&type=template&id=488b5484&"
import script from "./tick-list.vue?vue&type=script&lang=js&"
export * from "./tick-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports